import { MODEL_VERSION, SITE } from '@/app/constants';
import type { ModelVersion, TaskSettingsV2_0 } from '@/app/types';
import { HOME_MEDIA } from '../homeMedia';

interface ResourceAssets {
  url: string;
  mobileVideoSrc?: string;
  poster: string;
  mobilePoster?: string;
}

interface ResourceMeta {
  name: string;
  modelVersion?: ModelVersion;
  settings?: Partial<TaskSettingsV2_0>;
  isClaw?: boolean;
  clawWithReferenceImage?: boolean;
}

export type VideoResource = ResourceMeta & ResourceAssets;

interface ResourceConfig extends ResourceMeta {
  china: ResourceAssets;
  global: ResourceAssets;
}

// 首屏轮播：heroQ3 → Q41（图生视频预填），hero → Q42（图生视频预填），hero2 → S11（渲染「立即体验」按钮）
const HERO_LOCAL_ASSETS: ResourceAssets = {
  url: HOME_MEDIA.q42.videoSrc,
  poster: HOME_MEDIA.q42.poster,
};

const HERO_LOCAL_ASSETS_2: ResourceAssets = {
  url: HOME_MEDIA.s11.videoSrc,
  poster: HOME_MEDIA.s11.poster,
};

const HERO_LOCAL_ASSETS_Q3: ResourceAssets = {
  url: HOME_MEDIA.q41.videoSrc,
  poster: HOME_MEDIA.q41.poster,
};

const RESOURCE_CONFIGS: ResourceConfig[] = [
  {
    name: 'heroQ3',
    china: HERO_LOCAL_ASSETS_Q3,
    global: HERO_LOCAL_ASSETS_Q3,
    modelVersion: MODEL_VERSION.Q3,
    settings: {
      movement_amplitude: 'large',
    },
  },
  {
    name: 'hero',
    china: HERO_LOCAL_ASSETS,
    global: HERO_LOCAL_ASSETS,
    modelVersion: MODEL_VERSION.Q3,
    settings: {
      movement_amplitude: 'large',
    },
  },
  {
    name: 'hero2',
    china: HERO_LOCAL_ASSETS_2,
    global: HERO_LOCAL_ASSETS_2,
  },
];

// URL 里含中文（如「比心」「7月7日」）时，未编码字符会让 Next.js 生成的 preload Link 响应头
// 编码失败（header 只能是 ByteString / 0-255）。用 encodeURI 把非 ASCII 字符百分号编码，
// 已编码的 %20 等不受影响（encodeURI 不会转义 %）。
function encodeAssets(assets: ResourceAssets): ResourceAssets {
  return {
    url: encodeURI(assets.url),
    poster: encodeURI(assets.poster),
    ...(assets.mobileVideoSrc ? { mobileVideoSrc: encodeURI(assets.mobileVideoSrc) } : {}),
    ...(assets.mobilePoster ? { mobilePoster: encodeURI(assets.mobilePoster) } : {}),
  };
}

export const VIDEO_RESOURCES: VideoResource[] = RESOURCE_CONFIGS.map(({ china, global, ...rest }) => ({
  ...rest,
  ...encodeAssets(SITE === 'china' ? china : global),
}));
